import { render, staticRenderFns } from "./freshdeshFAQ.vue?vue&type=template&id=54ec121f&scoped=true"
import script from "./freshdeshFAQ.vue?vue&type=script&lang=js"
export * from "./freshdeshFAQ.vue?vue&type=script&lang=js"
import style0 from "./freshdeshFAQ.vue?vue&type=style&index=0&id=54ec121f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec121f",
  null
  
)

export default component.exports